const apply_grade = [
	{ label: '一年级', value: 1 },
	{ label: '二年级', value: 2 },
	{ label: '三年级', value: 3 },
	{ label: '四年级', value: 4 },
	{ label: '五年级', value: 5 },
	{ label: '六年级', value: 6 },
	{ label: '初一', value: 7 },
	{ label: '初二', value: 8 },
	{ label: '初三', value: 9 },
	{ label: '高一', value: 10 },
	{ label: '高二', value: 11 },
	{ label: '高三', value: 12 }
]
const typeList = [
	{ label: '单选题', value: 1 },
	{ label: '多选题', value: 2 },
	{ label: '填空题', value: 3 },
  { label: '节奏题', value: 4 },
  { label: '视唱旋律题', value: 5 },
  // { label: '演唱题', value: 7 },
	// { label: '可视化演唱题', value: 9 },
  { label: '演唱题', value: 9 },
  { label: '排序题', value: 10 },
	{ label: '连线题', value: 11 },
  { label: '填充题', value: 12 },
  { label: '拼图题', value: 13 },
	{ label: '配色题', value: 14 },
  { label: '识音练习题', value: 18 },
  { label: '弹奏题', value: 24 },
]
const questionType = {
	1: [
		{ label: '单选题', value: 1 },
		{ label: '多选题', value: 2 },
		{ label: '填空题', value: 3 },
		{ label: '连线题', value: 11 },
    { label: '排序题', value: 10 },
    // { label: '演唱题', value: 7 },
    { label: '节奏题', value: 4 },
		// { label: '可视化演唱题', value: 9 },
    { label: '演唱题', value: 9 },
    { label: '识音练习题', value: 18 },
    { label: '视唱旋律题', value: 5 },
    { label: '弹奏题', value: 24 },
	],
	2: [
		{ label: '单选题', value: 1 },
		{ label: '多选题', value: 2 },
		{ label: '填空题', value: 3 },
		{ label: '连线题', value: 11 },
    { label: '排序题', value: 10 },
    { label: '填充题', value: 12 },
		{ label: '拼图题', value: 13 },
		{ label: '配色题', value: 14 },
	]
}

const fb_apply_volume = [
	{ label: '上册', value: 1 },
	{ label: '下册', value: 2 },
	{ label: '全部', value: 3 }
]
const difficultyList = [
	{ label: '容易', value: '容易' },
	{ label: '中等', value: '中等' },
	{ label: '困难', value: '困难' }
]
const section = [
	{ val: 0, name: '全部' },
	{ val: 1, name: '小学' },
	{ val: 2, name: '初中' },
	{ val: 3, name: '高中' }
]
const primarySchool = [
	{ val: 1, name: '一年级' },
	{ val: 2, name: '二年级' },
	{ val: 3, name: '三年级' },
	{ val: 4, name: '四年级' },
	{ val: 5, name: '五年级' },
	{ val: 6, name: '六年级' }
]
const middleSchool = [
	{ val: 7, name: '初一' },
	{ val: 8, name: '初二' },
	{ val: 9, name: '初三' }
]
const highSchool = [
	{ val: 10, name: '高一' },
	{ val: 11, name: '高二' },
	{ val: 12, name: '高三' }
]

const all_grade = [
	{ val: 1, name: '一年级' },
	{ val: 2, name: '二年级' },
	{ val: 3, name: '三年级' },
	{ val: 4, name: '四年级' },
	{ val: 5, name: '五年级' },
	{ val: 6, name: '六年级' },
	{ val: 7, name: '初一' },
	{ val: 8, name: '初二' },
	{ val: 9, name: '初三' },
	{ val: 10, name: '高一' },
	{ val: 11, name: '高二' },
	{ val: 12, name: '高三' }
]
const musical = [
	{ val: '', name: '全部' },
	{ val: 'easy', name: '简谱' },
	{ val: 'big', name: '大谱表' },
	{ val: 'treble', name: '高音谱表' },
	{ val: 'bass', name: '低音谱表' },
	{ val: 'four', name: '合唱四声部' }
]
const audioTypes = {
	1: {
		ORDIDX: '1',
		NAME: '音频',
		CODE: 'VOICE1'
	},
	2: {
		ORDIDX: '2',
		NAME: '男高音',
		CODE: 'VOICE2'
	},
	3: {
		ORDIDX: '3',
		NAME: '男中音',
		CODE: 'VOICE3'
	},
	4: {
		ORDIDX: '4',
		NAME: '男低音',
		CODE: 'VOICE4'
	},
	5: {
		ORDIDX: '5',
		NAME: '女高音',
		CODE: 'VOICE5'
	},
	6: {
		ORDIDX: '6',
		NAME: '女中音',
		CODE: 'VOICE6'
	},
	7: {
		ORDIDX: '7',
		NAME: '女低音',
		CODE: 'VOICE7'
	},
	8: {
		ORDIDX: '8',
		NAME: '伴唱',
		CODE: 'BANCHANG'
	},
	9: {
		ORDIDX: '9',
		NAME: '范唱',
		CODE: 'FANCHANG'
	},
  10: {
    ORDIDX: '10',
    NAME: '演唱题-伴唱',
    CODE: 'SING_BANCHANG'
  }
}
const limits = {
	0: '私有',
	1: '公有'
}

// 2024.01.02 10:28 书荣
const adminIdentity = [
	{ name: '平台', id: 1 },
	// { name: '教研', id: 2 },
	{ name: '教师', id: 3 }
]
const teacherIdentity = [
	{ name: '自有', id: 5 },
	{ name: '校方', id: 4 },
	// { name: '教研', id: 2 },
	{ name: '平台', id: 1 }
]

const schoolIdentity = [
	{ name: '校方', id: 4 },
	// { name: '教研', id: 2 },
	{ name: '平台', id: 1 }
]

const researchIdentity = [
	{ name: '教研', id: 2 }
]

const noteMap = [
  'Do','Re', 'Mi', 'Fa', 'Sol', 'La', 'Si',
  '#Do', '#Re', '#Mi', '#Fa', '#Sol', '#La', '#Si',
  '♭Do', '♭Re', '♭Mi', '♭Fa', '♭Sol', '♭La', '♭Si',
  'xDo', 'xRe', 'xMi', 'xFa', 'xSol', 'xLa', 'xSi',
  '♭♭Do', '♭♭Re', '♭♭Mi', '♭♭Fa', '♭♭Sol', '♭♭La', '♭♭Si',
]

const sameMidiNoteMap = {
  '♭♭Do': ['♭♭Do', '♭Si', '#La'],
  '♭Do': ['♭Do', 'Si', 'xLa'],
  'Do': ['Do', '#Si', '♭♭Re'],
  '#Do': ['#Do', 'xSi', '♭Re'],
  'xDo': ['xDo', '♭♭Mi', 'Re'],

  '♭♭Re': ['♭♭Re', 'Do', '#Si'],
  '♭Re': ['♭Re', '#Do', 'xSi'],
  'Re': ['Re', 'xDo', '♭♭Mi'],
  '#Re': ['#Re', '♭Mi', '♭♭Fa'],
  'xRe': ['xRe', 'Mi', '♭Fa'],

  '♭♭Mi': ['♭♭Mi', 'Re', 'xDo'],
  '♭Mi': ['♭Mi', '#Re', '♭♭Fa'],
  'Mi': ['Mi', 'xRe', '♭Fa'],
  '#Mi': ['#Mi', 'Fa', '♭♭Sol'],
  'xMi': ['xMi', '#Fa', '♭Sol'],

  '♭♭Fa': ['♭♭Fa', '♭Mi', '#Re'],
  '♭Fa': ['♭Fa', 'Mi', 'xRe'],
  'Fa': ['Fa', '#Mi', '♭♭Sol'],
  '#Fa': ['#Fa', 'xMi', '♭Sol'],
  'xFa': ['xFa', 'Sol', '♭♭La'],

  '♭♭Sol': ['♭♭Sol', 'Fa', '#Mi'],
  '♭Sol': ['♭Sol', '#Fa', 'xMi'],
  'Sol': ['Sol', 'xFa', '♭♭La'],
  '#Sol': ['#Sol', '♭La'],
  'xSol': ['xSol', 'La', '♭♭La'],

  '♭♭La': ['♭♭La', 'Sol', 'xFa'],
  '♭La': ['♭La', '#Sol'],
  'La': ['La', 'xSol', '♭♭Si'],
  'xLa': ['xLa', 'Si', '♭Do'],
  '#La': ['#La', '♭Si', '♭♭Do'],

  '♭♭Si': ['♭♭Si', 'La', 'xSol'],
  '♭Si': ['♭Si', '#La', '♭♭Do'],
  'Si': ['Si', 'xLa', '♭Do'],
  '#Si': ['#Si', 'Do', '♭♭Re'],
  'xSi': ['xSi', '#Do', '♭Re']
}

const spectralPlaneMap = [
  { label: '简谱', value: 'jp' },
  { label: '五线谱', value: 'wxp' },
  { label: '简线混谱', value: 'jxhp' },
]
export {
	apply_grade,
	typeList,
	fb_apply_volume,
	difficultyList,
	primarySchool,
	middleSchool,
	highSchool,
	all_grade,
	section,
	musical,
	audioTypes,
	questionType,
	limits,
	adminIdentity,
	teacherIdentity,
	schoolIdentity,
  researchIdentity,
  noteMap,
  sameMidiNoteMap,
  spectralPlaneMap
}
